/**
 * Controller for creating / editing and cloning Inventory Items
 */

angular.module('qkr.inventory').controller('InventoryItemController', ['$scope', '$rootScope',
    '$timeout', 'inventoryItemInitData', 'inventoryService', 'inventoryItemService',
    'FormHelper', 'utils', '$uibModal', 'imageService', 'messageService', '$window',
    'gettextCatalog', 'appConfig', 'merchantService', 'taxService', 'variantService',
    '$location', 'inventoryErrorService',
    function($scope, $rootScope, $timeout, inventoryItemInitData, inventoryService, inventoryItemService,
             FormHelper, utils, $uibModal, imageService, messageService, $window,
             gettextCatalog, appConfig, merchantService, taxService, variantService,
             $location, inventoryErrorService) {
        const formHelper = new FormHelper($scope);

        $scope.BOOL_TYPE = 'bool';

        const reorderOptionSets = (optionSets) => {
            if (optionSets) {
                const filteredBoolOptions = optionSets.filter(option => option.type === $scope.BOOL_TYPE);
                const filteredOptions = optionSets.filter(option => option.type !== $scope.BOOL_TYPE);
                return filteredOptions.concat(filteredBoolOptions);
            }

            return optionSets;
        };

        // Privileges: Start
        $scope.isElevatedUser = appConfig.isElevatedUser;
        $scope.allowEditOnOutletLevel = inventoryItemInitData.allowEditOnOutletLevel;
        $scope.isEditable = ((appConfig.isElevatedUser && (!appConfig.outletLevel || $scope.allowEditOnOutletLevel)) &&
            merchantService.behaviour($rootScope.merchantInfo, 'inventoryPage.allowEdit')) || appConfig.isDepartmentManager;
        $scope.showAgeRestriction = inventoryItemInitData.showAgeRestriction;
        $scope.showStockLevel = inventoryItemInitData.showStockLevel;
        // Privileges: End

        // Product: Start
        $scope.merchant = inventoryItemInitData.merchant;
        $scope.outlet = inventoryItemInitData.outlet;
        $scope.currentProduct = inventoryItemInitData.product;

        $scope.currentProduct.optionSets = reorderOptionSets($scope.currentProduct.optionSets);
        $scope.form = angular.copy($scope.currentProduct);
        $scope.isNewProduct = inventoryItemInitData.isNewProduct;
        $scope.isClonedProduct = inventoryItemInitData.isClonedProduct;
        $scope.categories = inventoryItemInitData.categories;
        $scope.optionSets = inventoryItemInitData.optionSets;
        $scope.unusedOptions = inventoryItemService.getUnselectedOptionSets($scope.optionSets, $scope.form.optionSets);
        $scope.menuWarningMessage = inventoryItemInitData.menuWarningMessage;

        $scope.PROD_NOTE_MAX_LENGTH = 100;

        $scope.displayMenuWarningMessage = function() {
            if (!$scope.isNewProduct && $scope.isEditable && !utils.hasNoValue($scope.menuWarningMessage)) {
                $timeout(() => {
                    messageService.warning($scope.menuWarningMessage);
                });
            }
        };

        // Product: End

        // Tax: Start
        $scope.taxCalculationsEnabled = $scope.merchant.taxCalculationsEnabled;
        $scope.isTaxEditable = (appConfig.outletLevel && $scope.taxCalculationsEnabled);
        $scope.isTaxConfigurable = (!appConfig.outletLevel && $scope.taxCalculationsEnabled);
        $scope.priceTaxLabel = taxService.getPriceTaxLabelForMerchant(inventoryItemInitData.merchant);
        if ($scope.taxCalculationsEnabled) {
            $scope.taxConfig = inventoryItemInitData.taxConfig;
            $scope.minMaxTaxStr = inventoryItemInitData.taxConfig.minMaxTaxStr;
        }

        if ($scope.isElevatedUser && !$scope.isEditable && $scope.isTaxEditable
            && ($scope.taxConfig.isTaxChangeable || $scope.taxConfig.isSalesTaxChangeable)) {
            $timeout(() => {
                messageService.warning(gettextCatalog
                    .getString('Only tax settings specific to this outlet can be edited from this screen.'));
            });
        }
        // Tax: End

        // Screen State: Start
        $scope.saving = false;
        $scope.display = {};
        $scope.display.hasVariants = false;
        $scope.display.showVariantErrors = false;
        $scope.skuPlaceholderText = inventoryItemInitData.skuPlaceholderText;
        // Screen State: End

        // Variants: Start
        $scope.variantConfig = inventoryItemInitData.variantConfig;
        $scope.display.displayVariantErrors = false;
        $scope.display.displayVariantDeletionWarning = false;

        // This is the api that the variantBuilder exposes
        $scope.variantBuilder = {
            deleteAllVariants: null
        };

        $scope.setupVariants = function() {
            if ($scope.form.amountMinorUnits == null) {
                $scope.form.amountMinorUnits = 0;
            }
        };

        $scope.checkDisplayVariantDeletionWarning = function(e) {
            if ($scope.isEditable && $scope.variantConfig.variantInfrastructure.variantCoefficientList.length > 0) {
                $scope.display.displayVariantDeletionWarning = true;
                e.preventDefault();
            }
        };

        $scope.confirmDeleteAllVariants = function() {
            $scope.variantBuilder.deleteAllVariants();
            $timeout(() => {
                $scope.display.displayVariantDeletionWarning = false;
                $scope.display.hasVariants = false;
            });
        };

        $scope.cancelDeleteAllVariants = function() {
            $scope.display.displayVariantDeletionWarning = false;
        };

        $scope.changeStockTrackingEnabled = function(stockTrackingEnabled) {
            if(stockTrackingEnabled){
                $scope.sendNegativeDelta = true;
            }
        };

        $scope.changeStockLevel = function(oldStockQuantity) {
            variantService.changeDefaultStockQuantity($scope.variantConfig.variantInfrastructure,
                oldStockQuantity, $scope.form.stockQuantity);
        };
        // Variants: End

        // QKRD-5484 - We need to set purchaseNoteMandatory = false if no purchase note is enabled
        $scope.setPurchaseNoteMandatory = function() {
            if (!$scope.form.allowPurchaseNote || $scope.form.allowPurchaseNote === false) {
                $scope.form.purchaseNoteMandatory = false;
            }
        };

        // Form Handling: Start
        $scope.showSaveButton = function() {
            return ($scope.isEditable || (($scope.isTaxEditable && $scope.isElevatedUser)
                && ($scope.taxConfig.isTaxChangeable || $scope.taxConfig.isSalesTaxChangeable)));
        };

        $scope.performActualSave = function() {
            if ($scope.saving) {
                return;
            }
            $scope.saving = true;

            const product = angular.copy($scope.form);

            product.options = $scope.getOptions();
            product.category = $scope.getCategory();
            product.variants = angular.copy(variantService
                .getVariantsFromInfrastructure($scope.variantConfig.variantInfrastructure));
            if ($scope.taxCalculationsEnabled) {
                product.taxRates = $scope.taxConfig.updatedSalesTaxList;
            } else {
                product.taxRates = [];
            }

            if ($scope.isNewProduct) {
                inventoryService.createProduct(product, $scope.outlet).then((promise) => {
                    $scope.saveProductCallback(promise);
                }, (promise) => {
                    $scope.saveProductCallback(promise);
                });
            } else {
                const variantRemovalList = angular.copy(variantService
                    .getVariantRemovalListFromInfrastructure($scope.variantConfig.variantInfrastructure));
                const variantDetailRemovalList = angular.copy(variantService
                    .getVariantDetailRemovalListFromInfrastructure($scope.variantConfig.variantInfrastructure));

                angular.forEach(product.variants, (variant) => {
                     if ($scope.sendNegativeDelta && variant.stockQuantity === 0) {
                        variant.stockQuantity = -1; // set delta to -1
                        // work around to provide delta of -1 as server defaults stockQuantity to 1
                    }
                });

                inventoryService.updateProduct(product, $scope.outlet,
                    variantRemovalList, variantDetailRemovalList).then((promise) => {
                    $scope.saveProductCallback(promise);
                }, (promise) => {
                    $scope.saveProductCallback(promise);
                });
            }
        };

        // Handle response from attempted save
        $scope.saveProductCallback = function(response) {
            const r = formHelper.handleResponse(response);
            const salesTax = $scope.taxCalculationsEnabled ? $scope.taxConfig.currentProduct.salesTax : null;

            inventoryService.trimSystemGeneratedSkus(response.data);

            if (r.isSuccess()) {
                $scope.currentProduct = response.data;

                if ($scope.isTaxEditable && $scope.taxConfig.taxConfigurationChanges && appConfig.outletLevel) {
                    taxService.setTaxRateForInventoryItemAndOutlet($scope.currentProduct.id,
                        salesTax.id, $rootScope.outletInfo.id).then((taxResponse) => {
                        $scope.postSaveActions(response);
                    });
                } else {
                    $scope.postSaveActions(response);
                }
            } else {
                $scope.saving = false;
                const errors = inventoryErrorService.handleServerError(response.data.errors);
                // get first server error message - because this controller uses messageService to show errors,
                // it is probably best to show only the first error.
                const firstError = Object.keys(errors)[0];
                if (firstError) {
                    messageService.errorWithReason(errors[firstError], firstError, true);
                } else {
                    messageService.error(gettextCatalog.
                        getString('There was a problem saving. Please try again later.'));
                    // show generic error as previously was done
                }
            }
        };

        $scope.postSaveActions = function(response) {
            inventoryService.invalidateCache();
            inventoryService.loadInventory().then((data) => {
                $scope.saving = false;
                $rootScope.$broadcast('newProducts', data);

                // Reload the dashboard info
                $rootScope.$broadcast('reloadDashboard');

                $window.location.href = '#/inventory';
                utils.scrollToTop();
                messageService.saveAlert();

                if ($scope.isNewProduct) {
                    $rootScope.undefinedProducts++;
                }
            });

            // Force a reload of categories - new one could have been added or
            // If there was
            // A change then the count will have changes
            inventoryService.loadProductCategoriesForInventory().then((data) => {
                $rootScope.$broadcast('newCategories', data);
            });
        };

        // Set a default value so that I can configure the radio buttons
        $scope.transformForRendering = function() {
            $scope.form = angular.copy($scope.currentProduct);
            if ($scope.form == null) {
                $scope.form = {};
            }

            $scope.form.fullImageUrl = imageService.fullImageUrl($scope.form.imageUrl);

            // Create the options that the display binds to
            $scope.display = angular.copy($scope.form.options);
            if (utils.hasNoValue($scope.display)) {
                $scope.display = {};
            }

            if (!utils.hasNoValue($scope.form.category)) {
                $scope.display.categoryName = $scope.form.category.name;
            }

            if (!utils.hasNoValue($scope.form.ageRestricted) && $scope.form.ageRestricted > 0) {
                $scope.display.ageRestrictionEnabled = true;
            } else {
                $scope.display.ageRestrictionEnabled = false;
            }

            if ($scope.form.hasSystemDefaultVariant != null && !$scope.form.hasSystemDefaultVariant) {
                $scope.display.hasVariants = true;
            }
            $scope.showLedgerAnalysis =
                merchantService.behaviour($rootScope.merchantInfo, 'inventoryPage.showLedgerAnalysis');
        };
        // Form Handling: END

        $scope.showLedgerAnalysis = function() {
            return
        };

        $scope.getOptions = function() {
            let options = angular.copy($scope.display);

            if (utils.hasNoValue(options)) {
                options = {};
            }

            return options;
        };

        $scope.getCategory = function() {
            const productCategory = {};

            // Translate from selected category Id to the object
            if (!utils.hasNoValue($scope.display.categoryName)) {
                let found = false;
                angular.forEach($scope.categories, (category) => {
                    if (category.name === $scope.display.categoryName) {
                        productCategory.id = category.id;
                        productCategory.name = category.name;
                        found = true;
                    }
                });

                if (!found) {
                    productCategory.name = $scope.display.categoryName;
                }
            }
            return productCategory;
        };

        /*
         * Function to open the choose image modal dialog
         */
        $scope.selectProductImage = function($files) {
            imageService.editingImageReferenceName = 'PROD_' + Math.random();
            $rootScope.requiredAspectRatio = 1;
            $rootScope.scaledWidthAbsolute = 250;

            const modalInstance2 = $uibModal.open({
                template: require('../../templates/imageUpload.html'),
                controller: 'ImageController',
                windowClass: 'modal-image modal-borderless',
                size: 'sm',
                backdrop: 'static',
                resolve: {
                    inputImage() {
                        return $files;
                    }
                }
            });

            modalInstance2.result.then((selectedItem) => {
                if (selectedItem !== 'cancel') {
                    $scope.form.fullImageUrl = selectedItem.mediaValue + '?decache=' + new Date().getTime();
                    $scope.form.imageUrl = selectedItem.mediaValue + '?decache=' + new Date().getTime();

                    // Currently a product only has one media element - so replace
                    // This with this new values
                    // At some point we may want to support more in which case we
                    // May either append this new value
                    // Or replace an existing one if editing
                    $scope.form.mediaElements = [{
                        id: selectedItem.id
                    }];
                }
            }, () => {
            });

            // $rootScope.openImageModal(1, 250, "PROD_"+Math.random())
        };

        // Add an Option Set button pressed
        $scope.addOptionSet = function() {
            const modalInstance = $uibModal.open({
                template: require('../../templates/inventory/optionSet.html'),
                controller: 'OptionSetEditController',
                windowClass: 'fade',
                backdrop: 'static',
                resolve: {
                    optionSet() {
                        return null;
                    },
                    optionSetAction() {
                        return 'create';
                    },
                    optionSetList() {
                        return $scope.optionSets;
                    }
                }
            });

            modalInstance.result.then((res) => {
                if (res !== 'cancel') {
                    if (utils.hasNoValue($scope.form.optionSets))
                        $scope.form.optionSets = [];
                    $scope.form.optionSets.push(angular.copy(res));

                    // Reload the option sets
                    inventoryService.loadOptionSets().then((promise) => {
                        $scope.optionSets = promise;
                        $scope.unusedOptions = inventoryItemService.getUnselectedOptionSets($scope.optionSets,
                            $scope.form.optionSets);
                    });
                }
            }, () => {
            });
        };

        $scope.removeOptionSet = function(index) {
            $scope.form.optionSets.splice(index, 1);
            $scope.unusedOptions = inventoryItemService.getUnselectedOptionSets($scope.optionSets,
                $scope.form.optionSets);
        };

        $scope.setNewOptionSet = function(ev) {
            if (utils.hasNoValue($scope.form.optionSets)) {
                $scope.form.optionSets = [];
            }
            $scope.form.optionSets.push(angular.copy(ev));
            $scope.display.findOption = '';
            $scope.unusedOptions = inventoryItemService.getUnselectedOptionSets($scope.optionSets,
                $scope.form.optionSets);
        };

        $scope.save = function(isValid) {
            let valid = true;
            if ($scope.display.hasVariants) {
                if ($scope.inventoryItemForm.$error.variantConfig != null) {
                    $scope.display.displayVariantErrors = true;
                    valid = false;
                }
            }

            if(!isValid || !valid) {
                return;
            }

            $scope.performActualSave();
        };

        $scope.cancel = function() {
            utils.scrollToTop();
            $location.path('/inventory');
        };

        $scope.$watch('form.stockTrackingEnabled', (newValue) => {
            if($scope.isNewProduct && newValue) {
                $scope.form.stockQuantity = 0;
            }
        });

        // Initially call this function to setup any additional variables needed for display
        $scope.transformForRendering();
        $scope.displayMenuWarningMessage();
    }]);



// WEBPACK FOOTER //
// ./src/inventory/controllers/inventoryItem.controller.js